function toNumber(price) {
    return typeof price === 'number' ? price : parseFloat(price);
}
function toPositiveNumber(price) {
    return Math.max(0, toNumber(price));
}
export var formatAsPounds = function (price) {
    if (price === void 0) { price = 0; }
    var num = toNumber(price);
    var amount = Math.abs(num);
    return "".concat(num < 0 ? '−' : '', "\u00A3").concat(amount.toFixed(2));
};
export var formatAsPoundsOrPence = function (price) {
    if (price === void 0) { price = 0; }
    var num = toNumber(price);
    var amount = Math.abs(num);
    var pence = Math.round(amount * 100);
    if (pence === 0)
        return '';
    if (pence < 100)
        return "".concat(num < 0 ? '−' : '').concat(pence, "p");
    return formatAsPounds(price);
};
export var formatAsPositivePoundsOrPence = function (price) {
    if (price === void 0) { price = null; }
    if (price === null)
        return '';
    var positivePrice = toPositiveNumber(price);
    var pence = Math.round(positivePrice * 100);
    return pence ? formatAsPoundsOrPence(positivePrice) : '£0.00';
};
//# sourceMappingURL=format-currency.js.map